import { BUTTON_SIZE, BUTTON_TYPE, DSBottomSheet, DSButton, DSModal } from '@repo/design-system/index'
import classNames from 'classnames'
import { useState } from 'react'
import useIsMobile from '../../modules/hooks/common/useIsMobile'
import { n_book_lessons, n_common, n_credit, s_credit } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'

const ModalBody = ({ weeklyLessonPackages, setCurrentCouponBundle, currentCouponBundle }) => {
  const { t, isLocaleKO } = useTranslation()
  return (
    <div className="grid grid-cols-1 gap-y-[8px]">
      {weeklyLessonPackages.map((packageItem, index) => (
        <div
          key={index}
          onClick={() => setCurrentCouponBundle(packageItem)}
          className={classNames(
            'flex flex-row items-center border-[1px] rounded-[7px] border-[#EFF1F9] bg-white p-[12px] cursor-pointer',
            {
              '!border-[#503CC8] !bg-purple-50': currentCouponBundle.id == packageItem.id,
            }
          )}
        >
          <div className="Body2-14Bd text-[#80839e]">
            {packageItem.lesson_duration == 40 ? t(n_common.label_40min) : t(n_common.label_20min)}
          </div>
          <div className="flex flex-col items-start ml-[16px]">
            <div className="text-red-600 Body2-14Bd">{t(n_credit.weekly.popup_header2)}</div>
            <div className="Body1-16Bd text-gray-700">{isLocaleKO ? packageItem.name : packageItem.name_eng}</div>
            <div>
              {t(n_credit.weekly.popup2.subhead3)}: {t(s_credit.date(packageItem.exp_dates[0]))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

const WeeklyLessonPackagesModal = ({
  showWeeklyLessonPackages,
  setShowWeeklyLessonPackages,
  weeklyLessonPackages,
  setCouponBundle,
  couponBundle,
}) => {
  const { t } = useTranslation()
  const [currentCouponBundle, setCurrentCouponBundle] = useState(couponBundle)
  const isMobile = useIsMobile()

  return isMobile ? (
    <DSBottomSheet
      id="showWeeklyLessonPackages"
      isOpen={showWeeklyLessonPackages}
      setIsOpen={setShowWeeklyLessonPackages}
      closeOnDim={true}
      closeButton={true}
      noDim={false}
    >
      <div className="p-[20px]">
        <div className="Title2-18Bd">{t(n_credit.credit_select.title)}</div>
        <div className="mt-[20px]">
          <ModalBody
            weeklyLessonPackages={weeklyLessonPackages}
            setCurrentCouponBundle={setCurrentCouponBundle}
            currentCouponBundle={currentCouponBundle}
          />
        </div>
        <div className="w-full mt-[32px]">
          <DSButton
            size={BUTTON_SIZE.LG}
            onClick={() => {
              setCouponBundle(currentCouponBundle)
              setShowWeeklyLessonPackages(false)
            }}
          >
            <DSButton.Label className="whitespace-nowrap">
              {t(n_book_lessons.select_credit.btn_selected)}
            </DSButton.Label>
          </DSButton>
        </div>
      </div>
    </DSBottomSheet>
  ) : (
    <DSModal
      id="showWeeklyLessonPackages"
      isOpen={showWeeklyLessonPackages}
      setIsOpen={setShowWeeklyLessonPackages}
      size="xl"
      closeButton={true}
      closeOnDim={true}
    >
      <DSModal.Title>{t(n_credit.credit_select.title)}</DSModal.Title>
      <DSModal.Content>
        <ModalBody
          weeklyLessonPackages={weeklyLessonPackages}
          setCurrentCouponBundle={setCurrentCouponBundle}
          currentCouponBundle={currentCouponBundle}
        />
      </DSModal.Content>
      <DSModal.ButtonContainer direction="horizontal" classNameFromProps="w-full mt-[32px]">
        <DSButton size={BUTTON_SIZE.LG} onClick={() => setShowWeeklyLessonPackages(false)} type={BUTTON_TYPE.OUTLINE}>
          <DSButton.Label className="whitespace-nowrap">{t(n_common.btn_cancel)}</DSButton.Label>
        </DSButton>
        <DSButton
          size={BUTTON_SIZE.LG}
          onClick={() => {
            setCouponBundle(currentCouponBundle)
            setShowWeeklyLessonPackages(false)
          }}
        >
          <DSButton.Label className="whitespace-nowrap">{t(n_book_lessons.select_credit.btn_selected)}</DSButton.Label>
        </DSButton>
      </DSModal.ButtonContainer>
    </DSModal>
  )
}
export default WeeklyLessonPackagesModal
